// @flow

import * as React from 'react'
import type {
  ProductCategory,
  BabyListOptionalItem,
  Product,
  ProductSet,
} from '../../types'
import ProductCategoryNav from '../product-category-nav'

type Props = {
  +categories: $ReadOnlyArray<ProductCategory>,
  +optionals: $ReadOnlyArray<BabyListOptionalItem>,
  +laters: $ReadOnlyArray<Product | ProductSet>,
}

export default class IntakeSidebar extends React.Component<Props> {
  render() {
    const {categories, optionals, laters} = this.props
    return (
      <div className="intake-sidebar">
        <ProductCategoryNav
          categories={categories}
          optionals={optionals}
          laters={laters}
        />
      </div>
    )
  }
}
